import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const Navbar: React.FC = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	
	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	};

	const closeMenu = () => {
		setMenuOpen(false);
	};
	
	const links = (
		<>
			<li><NavLink to="/" end onClick={closeMenu}>Home</NavLink></li>
			{/* <li><NavLink to="/services" onClick={closeMenu}>Services</NavLink></li>
			<li><NavLink to="/story" onClick={closeMenu}>Our Story</NavLink></li>
			<li><NavLink to="/team" onClick={closeMenu}>Meet the Herd</NavLink></li>
			<li><NavLink to="/faq" onClick={closeMenu}>FAQ</NavLink></li> */}
			<li><span className="disabled" title="Coming soon!">Services</span></li>
			<li><span className="disabled" title="Coming soon!">Our Story</span></li>
			<li><span className="disabled" title="Coming soon!">Meet the Herd</span></li>
			<li><span className="disabled" title="Coming soon!">FAQ</span></li>
		</>
	);

	return (
		<nav className="navbar">
			{/* Desktop Links */}
			<ul className="nav-links-desktop">
				{links}
			</ul>

			{/* Mobile Hamburger */}
			{/* <button className="hamburger-button" onClick={toggleMenu} aria-label="Toggle navigation menu">
				<FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
			</button> */}
			
			{/* <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
				<ul className="nav-links-mobile">
					{links}
				</ul>
			</div> */}
			{/* {menuOpen && <div className="nav-overlay" onClick={closeMenu} />} */}
		</nav>
	);
};

export default Navbar;
